import React from 'react';

export type FaceMood = 'idle' | 'tense' | 'won' | 'lost';

/**
 * The face button, drawn rather than emoji so it sits properly in the dark
 * palette. It still does the classic thing of looking nervous while a cell is
 * held down.
 */
export function Face({ mood }: { mood: FaceMood }): React.ReactElement {
  const skin = mood === 'lost' ? '#c9b04a' : '#ffd24a';

  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <circle cx="16" cy="16" r="13" fill={skin} stroke="rgba(0,0,0,.35)" strokeWidth="1.5" />

      {mood === 'lost' ? (
        <g stroke="#3b2f0b" strokeWidth="2.2" strokeLinecap="round">
          <path d="M9 10 L14 15 M14 10 L9 15" />
          <path d="M18 10 L23 15 M23 10 L18 15" />
        </g>
      ) : mood === 'won' ? (
        // Sunglasses.
        <g fill="#23272f">
          <path d="M6 12 H26 V13.6 H6 Z" />
          <path d="M7.5 13.4 H14 V18 Q10.75 19.6 7.5 18 Z" />
          <path d="M18 13.4 H24.5 V18 Q21.25 19.6 18 18 Z" />
        </g>
      ) : (
        <g fill="#3b2f0b">
          <circle cx="11.5" cy="13" r="1.9" />
          <circle cx="20.5" cy="13" r="1.9" />
        </g>
      )}

      {mood === 'tense' ? (
        <ellipse cx="16" cy="21.5" rx="3" ry="3.4" fill="#3b2f0b" />
      ) : mood === 'lost' ? (
        <path
          d="M10.5 24 Q16 19.5 21.5 24"
          fill="none"
          stroke="#3b2f0b"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      ) : (
        <path
          d="M10 20 Q16 25.5 22 20"
          fill="none"
          stroke="#3b2f0b"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}
